import type { ModelingStyle, LanguageCode } from '@modelcast/types';

export interface Reference {
  name: string;
  email: string;
  website: string;
}

export interface ModelSignupFormState {
  name: string;
  username: string;
  bio: string;
  instagram: string;
  website: string;
  country: string;
  photos: PhotoUpload[];
  spacePhotos: PhotoUpload[];
  // Modeling preferences
  modelingStyles: ModelingStyle[];
  languages: LanguageCode[];
  defaultShowIdentity: boolean;
  cameraEquipment: string;
  // Verification fields
  verificationPhotos: PhotoUpload[];
  experience: string;
  references: [Reference, Reference];
}

export interface PhotoUpload {
  id: string;
  file: File;
  preview: string;
  resizedBlob?: Blob;
  width?: number;
  height?: number;
}

export const initialModelFormState: ModelSignupFormState = {
  name: '',
  username: '',
  bio: '',
  instagram: '',
  website: '',
  country: '',
  photos: [],
  spacePhotos: [],
  modelingStyles: [],
  languages: [],
  defaultShowIdentity: true,
  cameraEquipment: '',
  verificationPhotos: [],
  experience: '',
  references: [
    { name: '', email: '', website: '' },
    { name: '', email: '', website: '' },
  ],
};

// Options for form selects
export const MODELING_STYLE_OPTIONS: { value: ModelingStyle; label: string; description: string }[] = [
  { value: 'life_model', label: 'Life model (nude)', description: 'Typically asked to model nude, holding poses of varying lengths over the course of the session.' },
  { value: 'portraiture', label: 'Portraiture', description: 'Sessions focusing on close-ups of the face.' },
  { value: 'costumed', label: 'Costumed', description: 'You will likely need to provide your own costumes.' },
];

// Maximum dimensions for uploaded photos
export const MAX_PHOTO_WIDTH = 1200;
export const MAX_PHOTO_HEIGHT = 1600;
export const PHOTO_QUALITY = 0.85;
export const MAX_PHOTOS = 20;
export const REQUIRED_MODEL_PHOTOS = 6;
export const REQUIRED_SPACE_PHOTOS = 1;
export const MODEL_PHOTO_MIN_LONG_EDGE = 1600;
export const MODEL_PHOTO_MIN_SHORT_EDGE = 1000;
export const SPACE_PHOTO_MIN_LONG_EDGE = 1200;
export const SPACE_PHOTO_MIN_SHORT_EDGE = 800;
